import * as tslib_1 from "tslib";
import { SharePointQueryableInstance, SharePointQueryableCollection, defaultPath } from "./sharepointqueryable";
/**
 * Describes a collection of Hub Sites
 *
 */
var HubSites = /** @class */ (function (_super) {
    tslib_1.__extends(HubSites, _super);
    function HubSites() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a Hub Site from the collection by id
     *
     * @param id The Id of the Hub Site
     */
    HubSites.prototype.getById = function (id) {
        return new HubSite(this, "GetById?hubSiteId='" + id + "'");
    };
    HubSites = tslib_1.__decorate([
        defaultPath("_api/hubsites")
    ], HubSites);
    return HubSites;
}(SharePointQueryableCollection));
export { HubSites };
var HubSite = /** @class */ (function (_super) {
    tslib_1.__extends(HubSite, _super);
    function HubSite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HubSite;
}(SharePointQueryableInstance));
export { HubSite };
//# sourceMappingURL=hubsites.js.map